import React, { useState } from 'react';
import { archiveAPI } from '../api/archive';
import { Archive, AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';

export default function ArchiveButton({ entity, id, name, onArchived, className = '' }) {
  const [cascadeModal, setCascadeModal] = useState(null);
  const [archiving, setArchiving] = useState(false);

  const handleArchive = async () => {
    if (!window.confirm(`¿Archivar "${name}"? Dejara de aparecer en la lista principal.`)) return;
    setArchiving(true);
    try {
      await archiveAPI.archive(entity, id);
      toast.success('Archivado correctamente');
      onArchived?.();
    } catch (err) {
      const status = err?.response?.status;
      const data = err?.response?.data;
      // API returns 409 with detail as nested object or string
      if (status === 409) {
        const detail = typeof data?.detail === 'object' ? data.detail : data;
        const msg = detail?.message || detail?.detail || 'Este elemento tiene dependencias activas.';
        const projects = detail?.projects_count ?? detail?.active_projects ?? 0;
        const events = detail?.events_count ?? detail?.active_events ?? 0;
        setCascadeModal({ message: msg, projects, events });
        return;
      }
      const msg = typeof data?.detail === 'string' ? data.detail
        : typeof data?.detail?.message === 'string' ? data.detail.message
        : 'Error al archivar';
      toast.error(msg);
    } finally { setArchiving(false); }
  };

  const handleCascade = async () => {
    setCascadeModal(null);
    setArchiving(true);
    try {
      await archiveAPI.archiveCascade(entity, id);
      toast.success('Archivado en cascada correctamente');
      onArchived?.();
    } catch (err) {
      const data = err?.response?.data;
      const msg = typeof data?.detail === 'string' ? data.detail
        : typeof data?.detail?.message === 'string' ? data.detail.message
        : 'Error al archivar en cascada';
      toast.error(msg);
    } finally { setArchiving(false); }
  };

  return (
    <>
      <button onClick={handleArchive} disabled={archiving}
        className={`flex items-center gap-1.5 text-xs text-slate-400 hover:text-red-500 transition-colors disabled:opacity-50 ${className}`}
        title="Archivar" aria-label={`Archivar ${name}`} data-testid={`archive-${id}`}>
        <Archive size={13} />
        {className.includes('show-label') && <span>Archivar</span>}
      </button>

      {cascadeModal && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={e => e.stopPropagation()}>
          <div className="bg-white rounded-sm shadow-xl w-full max-w-sm animate-fade-in p-6">
            <div className="flex items-center gap-2 mb-3">
              <AlertTriangle size={20} className="text-orange-500" />
              <h3 className="font-bold text-soem-navy">Confirmar archivado en cascada</h3>
            </div>
            <p className="text-sm text-slate-600 mb-2">{cascadeModal.message}</p>
            {(cascadeModal.projects > 0 || cascadeModal.events > 0) && (
              <div className="bg-orange-50 border border-orange-200 rounded-sm p-3 mb-4 text-sm text-orange-800">
                {cascadeModal.projects > 0 && <p>{cascadeModal.projects} proyecto(s) activo(s)</p>}
                {cascadeModal.events > 0 && <p>{cascadeModal.events} evento(s) activo(s)</p>}
                <p className="mt-1 font-medium">Se archivaran TODOS en cascada.</p>
              </div>
            )}
            <p className="text-xs text-slate-400 mb-4">Esta accion se puede revertir desde el modulo Archivo.</p>
            <div className="flex gap-3">
              <button onClick={handleCascade} disabled={archiving}
                className="flex-1 py-2.5 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-sm transition-colors disabled:opacity-50"
                data-testid="confirm-cascade">
                Archivar todo en cascada
              </button>
              <button onClick={() => setCascadeModal(null)} className="soem-btn-secondary flex-1 py-2.5 text-sm">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
